var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeadset = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.324,
    height: 16.655,
    viewBox: "0 0 13.324 16.655",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "headset",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M8.662,1.11A5.552,5.552,0,0,0,3.11,6.662v5H2v-5a6.662,6.662,0,1,1,13.324,0v5h-1.11v-5A5.552,5.552,0,0,0,8.662,1.11Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M11.993,8.11A1.11,1.11,0,0,1,13.1,7h2.221v4.441a1.11,1.11,0,0,1-1.11,1.11H13.1a1.11,1.11,0,0,1-1.11-1.11Zm-6.662,0A1.11,1.11,0,0,0,4.221,7H2v4.441a1.11,1.11,0,0,0,1.11,1.11h1.11a1.11,1.11,0,0,0,1.11-1.11Z",
    transform: "translate(0 0.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M14.162,8.5a.555.555,0,0,1,.555.555v3.331a2.776,2.776,0,0,1-2.776,2.776H8.055a.555.555,0,0,1,0-1.11h3.886a1.665,1.665,0,0,0,1.665-1.665V9.055A.555.555,0,0,1,14.162,8.5Z",
    transform: "translate(0.607 0.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M6.5,14.11A1.11,1.11,0,0,1,7.61,13h1.11a1.11,1.11,0,0,1,0,2.221H7.61A1.11,1.11,0,0,1,6.5,14.11Z",
    transform: "translate(0.496 1.434)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeadset);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy4zMjQiIGhlaWdodD0iMTYuNjU1IiB2aWV3Qm94PSIwIDAgMTMuMzI0IDE2LjY1NSI+CiAgPGcgaWQ9ImhlYWRzZXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yKSI+CiAgICA8cGF0aCBpZD0iUGF0aF84OTAiIGRhdGEtbmFtZT0iUGF0aCA4OTAiIGQ9Ik04LjY2MiwxLjExQTUuNTUyLDUuNTUyLDAsMCwwLDMuMTEsNi42NjJ2NUgydi01YTYuNjYyLDYuNjYyLDAsMSwxLDEzLjMyNCwwdjVoLTEuMTF2LTVBNS41NTIsNS41NTIsMCwwLDAsOC42NjIsMS4xMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDApIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iUGF0aF84OTEiIGRhdGEtbmFtZT0iUGF0aCA4OTEiIGQ9Ik0xMS45OTMsOC4xMUExLjExLDEuMTEsMCwwLDEsMTMuMSw3aDIuMjIxdjQuNDQxYTEuMTEsMS4xMSwwLDAsMS0xLjExLDEuMTFIMTMuMWExLjExLDEuMTEsMCwwLDEtMS4xMS0xLjExWm0tNi42NjIsMEExLjExLDEuMTEsMCwwLDAsNC4yMjEsN0gydjQuNDQxYTEuMTEsMS4xMSwwLDAsMCwxLjExLDEuMTFoMS4xMWExLjExLDEuMTEsMCwwLDAsMS4xMS0xLjExWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjc3MikiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzg5MiIgZGF0YS1uYW1lPSJQYXRoIDg5MiIgZD0iTTE0LjE2Miw4LjVhLjU1NS41NTUsMCwwLDEsLjU1NS41NTV2My4zMzFhMi43NzYsMi43NzYsMCwwLDEtMi43NzYsMi43NzZIOC4wNTVhLjU1NS41NTUsMCwwLDEsMC0xLjExaDMuODg2YTEuNjY1LDEuNjY1LDAsMCwwLDEuNjY1LTEuNjY1VjkuMDU1QS41NTUuNTU1LDAsMCwxLDE0LjE2Miw4LjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjYwNyAwLjkzOCkiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzg5MyIgZGF0YS1uYW1lPSJQYXRoIDg5MyIgZD0iTTYuNSwxNC4xMUExLjExLDEuMTEsMCwwLDEsNy42MSwxM2gxLjExYTEuMTEsMS4xMSwwLDAsMSwwLDIuMjIxSDcuNjFBMS4xMSwxLjExLDAsMCwxLDYuNSwxNC4xMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDk2IDEuNDM0KSIgZmlsbD0iI2ZmZiIvPgogIDwvZz4KPC9zdmc+Cg==";